const config = {
  baseURL: window.APP_API_URL ?? "https://chatbot-dev.portnet.ma/",
  aiChatBotUrl:
    window.APP_CHATBOT_API_URL ?? "https://chatbot-preprod-api.portnet.ma",
  referentielBaseURL:
    window.APP_REFERENTIEL_API_URL ?? "http://localhost:8080/",
  frontUrl: document?.referrer?.includes("portnet")
    ? window.APP_FRONT_PORTNET_URL ?? "https://chatbot-dev.portnet.ma"
    : window.APP_FRONT_MIC_URL ?? "https://chatbot-dev.portnet.ma",
  googleClientId:
    (!window.location.href?.includes("dev") &&
      process.env.REACT_APP_GOOGLE_CLIENT_ID) ||
    "6073115372-qsucisu09ond8ep03819uncbjup2k30b.apps.googleusercontent.com",
  appleClientId:
    (!window.location.href?.includes("dev") &&
      process.env.REACT_APP_APPLE_CLIENT_ID) ||
    "ma.portnet.chatbot-dev",
  appleRedirectUri:
    (!window.location.href?.includes("dev") &&
      process.env.REACT_APP_APPLE_REDIRECT_URI) ||
    "https://chatbot-dev.portnet.ma/auth/callback",
  appleState: window.APP_APPLE_STATE ?? "origin:web",
  appleScope: window.APP_APPLE_SCOPE ?? "name email",
  appleUsePopup: window.APP_APPLE_USE_POPUP ?? true,
  linkedInClientId:
    (!window.location.href?.includes("dev") &&
      process.env.REACT_APP_LINKEDIN_CLIENT_ID) ||
    "786j0budryyr60",
  linkedInState:
    (!window.location.href?.includes("dev") &&
      process.env.REACT_APP_LINKEDIN_STATE) ||
    "WPL_AP1.0txoQIYGHY0sNej5.CjzWcQ==",
  appName: window.APP_NAME ?? "TIJARIA",
  
  recaptchaSiteKey:
    window.CAPTCHA_SITE_KEY ?? "6LfB4LorAAAAAFO2eDMOFiLD_8uNwsJCAmMpJjCN",
  crossOrigineUrls: "*"
};

export default config;
